// Utility functions for managing game records in localStorage

export const saveGameRecord = (gameType, score, totalQuestions) => {
  try {
    const records = getGameRecords(gameType);
    const newRecord = {
      date: new Date().toISOString(),
      score,
      totalQuestions,
      percentage: Math.round((score / totalQuestions) * 100)
    };
    
    records.push(newRecord);
    // Keep only the last 10 records
    const recentRecords = records.slice(-10);
    localStorage.setItem(`gameRecords_${gameType}`, JSON.stringify(recentRecords));
    return true;
  } catch (error) {
    console.error('Error saving game record:', error);
    return false;
  }
};

export const getGameRecords = (gameType) => {
  try {
    const records = localStorage.getItem(`gameRecords_${gameType}`);
    return records ? JSON.parse(records) : [];
  } catch (error) {
    console.error('Error getting game records:', error);
    return [];
  }
};

export const getBestScore = (gameType) => {
  try {
    const records = getGameRecords(gameType);
    if (records.length === 0) return null;
    
    return records.reduce((best, current) => {
      return current.percentage > best.percentage ? current : best;
    }, records[0]);
  } catch (error) {
    console.error('Error getting best score:', error);
    return null;
  }
}; 